module.exports = __webpack_public_path__ + "img/ch15_07_草莓滚落.351f5900.jpg";